import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-deposit-redirect-dialog',
  templateUrl: './deposit-redirect-dialog.component.html',
  styleUrls: ['./deposit-redirect-dialog.component.scss']
})
export class DepositRedirectDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DepositRedirectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { redirectUrl: string },
  ) { }

  ngOnInit(): void {
  }
  
  cancel() {
    this.dialogRef.close();
  }
}
